var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconmaterialMoreVert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-more-vert",
    "data-name": "Icon material-more-vert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 44,
    viewBox: "0 0 11 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-more-vert-2",
    "data-name": "Icon material-more-vert",
    d: "M20.5,17A5.5,5.5,0,1,0,15,11.5,5.516,5.516,0,0,0,20.5,17Zm0,5.5A5.5,5.5,0,1,0,26,28,5.516,5.516,0,0,0,20.5,22.5Zm0,16.5A5.5,5.5,0,1,0,26,44.5,5.516,5.516,0,0,0,20.5,39Z",
    transform: "translate(-15 -6)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialMoreVert);
export default __webpack_public_path__ + "static/media/Icon material-more-vert.ef2ecf1da2e120c94e62bcf12245183b.svg";
export { ForwardRef as ReactComponent };